module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recomendation-letters"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('router-link', {
    staticClass: "button centered",
    attrs: {
      "to": {
        name: 'RecommendationLetterCreator'
      }
    }
  }, [_vm._v("\n        Добавить рекомендательное письмо\n      ")])], 1), _vm._v(" "), _c('draggable', {
    staticClass: "columns is-multiline mt-10 letters-columns",
    model: {
      value: (_vm.recommendationLettersObject),
      callback: function($$v) {
        _vm.recommendationLettersObject = $$v
      },
      expression: "recommendationLettersObject"
    }
  }, _vm._l((_vm.recommendationLetters), function(letter) {
    return _c('RecommendationLetterItem', {
      key: letter.id,
      staticClass: "column is-one-third",
      attrs: {
        "letter": letter
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e06e834"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/RecommendationLetters.vue
// module id = 963
// module chunks = 0